import { type ClassValue, clsx } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

// The custom `boxShadow` entries of tailwind.config.ts: without them `cn()` would keep both a default shadow
// and a custom one on the same element and leave the result to the order of the generated CSS.
const twMerge = extendTailwindMerge({
  extend: {
    theme: {
      shadow: ['container'],
    },
  },
});

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export { clsx as cx };
